module.exports = {"360829100":"平都镇","360829101":"浒坑镇","360829102":"洲湖镇","360829103":"横龙镇","360829104":"洋溪镇","360829105":"严田镇","360829106":"枫田镇","360829107":"羊狮慕镇","360829200":"竹江乡","360829201":"瓜畲乡","360829202":"钱山乡","360829203":"赤谷乡","360829204":"山庄乡","360829205":"洋门乡","360829206":"金田乡","360829207":"彭坊乡","360829209":"寮塘乡","360829210":"甘洛乡","360829211":"章庄乡","360829400":"江西安福高新技术产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360829.json
// module id = 1428
// module chunks = 0